import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";

import { Input, Row, Card, Form, DatePicker, Col, Divider, Spin } from "antd";
import { BOM } from "../../../../../services/definedMethod";
import cnt from "../../../../../services/definedConstant";
import CustomButton from "../../../../../components/custom/CustomButton";
import MainLayout from "../../../../../components/layouts/MainLayout";
import TopContent from "../../../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../../../customer.config";
import { showCheckerApprovalModal } from "../../../../../components/CheckerModal";

const { TextArea } = Input;
const ApproveSavingsAcc = (props) => {
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    console.log(state);
  }, []);

  // const disabledAfterCurrentDate = (current) => {
  //   return current && current.valueOf() > Date.now();
  // };

  function onCancel() {
    navigate("/detail-savings-account", { state: state });
  }

  const onSubmit = (formValues) => {
    const url = `${apiConfig.savingsAccounts}/${state.id}`;
    const params = {
      command: "approve",
    };
    formValues.approvedOnDate = BOM.DateTime(formValues.approvedOnDate, "only-date");
    const body = {
      ...formValues,
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      method: "POST",
      session,
      params,
    };
    // console.log(body);
    // return
    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, "Savings Account was updated");
          navigate("/detail-savings-account", {
            state: { ...state, statusValue: "approved" },
          });
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/detail-savings-account", { state: { ...state } });
          setIsLoading(false);
        },
      }
    );
  };

  return (
    <MainLayout isEnableRightSidebar={true}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent pageTitle={"Approve Saving Account"} pageItems={[]} />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={form} layout="vertical" onFinish={onSubmit}>
            <Row>
              <Divider orientation="left">{`Account No: ${state.accountNo}`}</Divider>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={"Approved on"}
                  name={"approvedOnDate"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.date),
                    },
                  ]}
                >
                  <DatePicker
                    disabledDate={BOM.DisabledAfterCurrentDate}
                    style={{ width: "100%", height: 35 }}
                  />
                </Form.Item>
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item label={"Note"} name={"note"}>
                  <TextArea
                    placeholder={BOM.handlePlaceholderMsg("Note")}
                    autoSize={{
                      minRows: 2,
                      maxRows: 6,
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Divider />
              <CustomButton
                content="Submit"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                htmlType="submit"
                backgroundColor="#92428B"
                colorText="white"
                hoverBackground="#AD4EA7"
              />

              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};
export default ApproveSavingsAcc;
